module.exports = __webpack_public_path__ + "images/trophy_icon.png";